The type of event, i.e. PositionProfileUpdated. This corresponds to the `Event.typeCode` field in the GraphQL schema.
